<template>
  <div class="announcements">
    <div
      v-for="announcement in announcements"
      class="announcement"
      :class="`sev-${announcement.severity}`">
      <span v-if="announcement.title" class="title">
        <font-awesome-icon
          v-if="announcement.severity == 'announcement'"
          :icon="faIcons.faMegaphone" />
        <font-awesome-icon
          v-if="announcement.severity == 'notice'"
          :icon="faIcons.faInfoCircle" />
        <font-awesome-icon
          v-if="announcement.severity == 'maintenance'"
          :icon="faIcons.faWrench" />
        <font-awesome-icon
          v-if="announcement.severity == 'warning'"
          :icon="faIcons.faExclamationTriangle" />
        &nbsp;{{ announcement.title }}
      </span>
      <p v-html="announcement.message"></p>
    </div>
  </div>
</template>

<script>
import * as api from 'assets/js/api';

export default {
  name: 'q-announcement',

  data() {
    return {
      announcements: [],
    };
  },

  methods: {
    // fetchAnnouncements fetches announcements from the server.
    async fetchAnnouncements() {
      try {
        const resp = await api.Get(api.urls.ANNOUNCEMENTS_LOGIN);
        this.announcements = resp.data;
      } catch (err) {
        // Fail silently.
      }
    },
  },

  mounted() {
    this.fetchAnnouncements();
  },

  props: {
  },
};
</script>

<style lang="scss" scoped>
  .announcements {
    position: absolute;
    bottom: 0;
    width: 100%;

    .announcement:first-child {
      border-top-left-radius: 0.5rem;
      border-top-right-radius: 0.5rem;
    }

    .announcement {
      max-width: 600px;
      margin: 0 auto;
      text-align: left;
      font-size: 1.2rem;
      padding: 0.8em 1.0em 1.2em 1.0em;

      .title {
        font-weight: bold;
        display: block;
        margin-bottom: 0.3em;
      }
      p {
        margin: 0;
        :deep(a) {
          color: #FFFFFF;
        }
      }
    }
    .announcement.sev-notice,
    .announcement.sev-announcement {
      background-color: #005C72;
      color: #FFFFFF;
    }
    .announcement.sev-maintenance {
      background-color: #d96302;
      color: #FFFFFF;
    }
    .announcement.sev-warning {
      background-color: #700500;
      color: #FFFFFF;
    }
  }
</style>
